<template>
    <div>
        <rkm-table
            :fields="fields"
            :items="data.model.encaminhamentos"
            hide-filters
            hide-pagination
        >
            <template v-slot:cell(actions)="{index, item}">
                <rkm-button
                    @click="print(item)"
                    color="info"
                    small
                    title="Visualizar rascunho"
                >
                    <rkm-icon icon="eye" />
                </rkm-button>

                <rkm-button
                    @click="$refs.Modal.open(item)"
                    color="primary"
                    small
                    title="Editar"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    @click="destroy(index)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>

        <rkm-area
            background-color="primary"
            closed
            title="Histórico de encaminhamentos"
            type="box"
        >
            <rkm-list
                :items="data.form.encaminhamentos"
                hide-filters
                hide-pagination
                item-cursor="default"
            >
                <template v-slot="{item}">
                    <rkm-row>
                        <rkm-col>
                            <strong>Data / Hora</strong><br />{{item.dataHora}}
                        </rkm-col>

                        <rkm-col>
                            <strong>Setor</strong><br />{{item.centroCusto.setor.nome}}
                        </rkm-col>

                        <rkm-col>
                            <strong>Profissional</strong><br />{{item.lotacao.profissional.nome}} - {{item.lotacao.ocupacao.nome}}
                        </rkm-col>
                    </rkm-row>

                    <hr />

                    <rkm-row>
                        <rkm-col cols="12">
                            <strong>Tipo</strong><br />{{item.tipoDescricao}}
                        </rkm-col>
                    </rkm-row>

                    <template v-if="item.tipoId === enums.encaminhamento.ENCAMINHAMENTO_INTERSETORIAL">
                        <rkm-row>
                            <rkm-col cols="6">
                                <strong>Unidade</strong><br />{{item.intersetorialUnidadeNomeFantasia}}
                            </rkm-col>

                            <rkm-col cols="6">
                                <strong>Local de atendimento</strong><br />{{item.intersetorialInfraestruturaNome}}
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                             <rkm-col cols="6">
                                <strong>CIAP 2</strong><br />{{item.servicoEspecializadoCiapDescricao}}
                            </rkm-col>

                            <rkm-col cols="6">
                                <strong>CID 10</strong><br />{{item.servicoEspecializadoCidDescricao}}
                            </rkm-col>
                        </rkm-row>
                    </template>

                    <template v-else-if="item.tipoId === enums.encaminhamento.ENCAMINHAMENTO_PARA_SERVICO_ESPECIALIZADO">
                        <rkm-row>
                            <rkm-col cols="6">
                                <strong>Especialidade</strong><br />{{item.servicoEspecializadoEspecialidadeNome}}
                            </rkm-col>

                            <rkm-col cols="6">
                                <strong>Complemento</strong><br />{{item.servicoEspecializadoComplemento}}
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col cols="6">
                                <strong>CIAP 2</strong><br />{{item.servicoEspecializadoCiapDescricao}}
                            </rkm-col>

                            <rkm-col cols="6">
                                <strong>CID 10</strong><br />{{item.servicoEspecializadoCidDescricao}}
                            </rkm-col>

                            <rkm-col cols="6">
                                <strong>Classificação de risco</strong><br />{{item.servicoEspecializadoClassificacaoRiscoNome}}
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col cols="12">
                                <strong>Motivo</strong><br />{{item.servicoEspecializadoMotivo}}
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col cols="12">
                                <strong>Observações</strong><br />{{item.servicoEspecializadoObservacao}}
                            </rkm-col>
                        </rkm-row>
                    </template>

                    <template v-else-if="item.tipoId === enums.encaminhamento.ENCAMINHAMENTO_PARA_CAPS">
                        <rkm-row>
                             <rkm-col cols="6">
                                <strong>CIAP 2</strong><br />{{item.servicoEspecializadoCiapDescricao}}
                            </rkm-col>

                            <rkm-col cols="6">
                                <strong>CID 10</strong><br />{{item.servicoEspecializadoCidDescricao}}
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col cols="12">
                                <strong>Motivo</strong><br />{{item.servicoEspecializadoMotivo}}
                            </rkm-col>
                        </rkm-row>
                    </template>

                    <template v-else>
                        <rkm-row>
                             <rkm-col cols="6">
                                <strong>CIAP 2</strong><br />{{item.servicoEspecializadoCiapDescricao}}
                            </rkm-col>

                            <rkm-col cols="6">
                                <strong>CID 10</strong><br />{{item.servicoEspecializadoCidDescricao}}
                            </rkm-col>
                        </rkm-row>
                    </template>
                </template>
            </rkm-list>
        </rkm-area>

        <Modal
            :data="data"
            ref="Modal"
        />
    </div>
</template>

<script>
// Components.
import Modal from './Modal'

// Enums.
import encaminhamento from '@/enums/atencao-basica/atendimento-individual/encaminhamento'

// Vuex.
import {mapActions} from 'vuex'

// Mixins.
import {error, file, repository, stringCase} from '@/mixins'

export default {
    components: {Modal},
    data: () => ({
        enums: {encaminhamento},
        fields: [
            {key: 'tipo.descricao', label: 'Tipo', sortable: true},
            {class: 'col-min text-center', key: 'actions', label: 'Ações'},
        ],
    }),
    created() {
        this.repositories = {
            pdf: this.getConectaSusRepository('impressao.ambulatorio'),
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        destroy(index) {
            this.showDeleteConfirmation('Deseja realmente excluir o encaminhamento?', async () => {
                this.data.model.encaminhamentos.splice(index, 1)
            })
        },
        print(item) {

            item.rascunho = true

            this.repositories.pdf.encaminhamento(this.data.additionals.paciente.id, item)
                .then(({data, headers}) => this.openFile(data, headers['content-type']))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        }
    },
    mixins: [error, file, repository, stringCase],
    props: {
        data: {type: Object, required: true},
    },
}
</script>